import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "articlecontent" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Hero = _resolveComponent("Hero")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createVNode(_component_Hero, { article: _ctx.article }, null, 8, ["article"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        innerHTML: _ctx.article.content
      }, null, 8, _hoisted_2)
    ])
  ]))
}